var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91306 14.8869L12.9132 6.88669L9.11331 3.08676L1.11312 11.0869C1.00298 11.1972 0.924747 11.3352 0.886709 11.4864L0 16L4.51275 15.1133C4.66426 15.0754 4.80286 14.9971 4.91306 14.8869ZM15.4959 4.30405C15.8187 3.98117 16 3.54331 16 3.08676C16 2.63021 15.8187 2.19235 15.4959 1.86947L14.1305 0.50411C13.8077 0.181328 13.3698 0 12.9132 0C12.4567 0 12.0188 0.181328 11.696 0.50411L10.3306 1.86947L14.1305 5.66941L15.4959 4.30405Z",
    fill: "#C6CCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cf3fee55667530b6c9ef92f84c2d2ab7.svg";
export { ForwardRef as ReactComponent };